import * as yup from 'yup'
import { dateYupOptional, dateYupRequired } from '../validators/dateYup'

export const dateRangePage = propOverrides => {
  const props = {
    pageId: 'date_range_page',
    pageTitle: null,
    pageDescription: null,
    startFieldName: 'start_date',
    startHint: null,
    startLabel: 'Start date',
    startLabelClassName: null,
    startRequired: true,
    endFieldName: 'end_date',
    endHint: null,
    endLabel: 'End date',
    endLabelClassName: null,
    endRequired: true,
    ...propOverrides
  }

  return {
    id: props.pageId,
    title: props.pageTitle,
    description: props.pageDescription,
    validation: yup.object().shape({
      [props.startFieldName]: props.startRequired
        ? dateYupRequired()
        : dateYupOptional(),
      [props.endFieldName]: props.endRequired
        ? dateYupRequired()
        : dateYupOptional()
    }),
    fields: [
      {
        type: 'date',
        name: props.startFieldName,
        label: props.startLabel,
        hint: props.startHint,
        labelClassName: props.startLabelClassName,
        overrideDefaultMinMax: true
      },
      {
        type: 'date',
        name: props.endFieldName,
        label: props.endLabel,
        hint: props.endHint,
        labelClassName: props.endLabelClassName,
        overrideDefaultMinMax: true
      }
    ]
  }
}
